import './App.css';
import {Route, Routes} from "react-router-dom";
import {Main} from "./pages/Main";
import {Nav} from "./pages/Nav";
import {Works} from "./pages/Works";
import {WorkDetail} from "./pages/WorkDetail";
import {Service} from "./pages/Service";
import {Career} from "./pages/Career";
import {Contact} from "./pages/Contact";
import {sendRequest} from "./static/js/common";
import {useEffect} from "react";

function App() {

  const saveTodayVisit = () => {
    sendRequest('stat/today-visit/', 'POST', {})
  }

  const saveReferrer = (referrer) => {
    sendRequest('stat/inflow-url/', 'POST', {
      url: referrer
    })
  }

  useEffect(() => {
    saveTodayVisit()
    if(document.referrer) {
      saveReferrer(document.referrer)
    }
  }, []);

  return (
    <div
      className={`root`}
      style={{
        display: 'flex',
        padding: "0 0 0 0",
        width: '100%',
        // minWidth: window.innerWidth,
        overflowX: "hidden",
        minHeight: "100%",
        backgroundColor: '#181818',
        paddingLeft: 0,
        paddingRight: 0
      }}
    >
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/nav" element={<Nav />} />
        <Route path="/works" element={<Works />} />
        <Route path="/work-detail/:id" element={<WorkDetail />} />
        <Route path="/service" element={<Service />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;
